import React, { FC } from 'react';
import { Button, List, ListItemButton, ListItemText } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DHDialog from 'components/shared/dh-dialog/dh-dialog.component';

export type PriceListOption = {
    _id: string;
    name: string;
    currency: string;
    isStandardPriceList?: boolean;
};

type PriceListSelectorDialogProps = {
    open: boolean;
    title: string;
    options: PriceListOption[];
    selectedId?: string;
    onSelect: (priceListId: string) => void;
    onClose: () => void;
};

const PriceListSelectorDialog: FC<PriceListSelectorDialogProps> = ({
    open,
    title,
    options,
    selectedId,
    onSelect,
    onClose,
}: PriceListSelectorDialogProps) => {
    const { t: translate } = useTranslation(['common']);

    return (
        <DHDialog
            title={title}
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            actions={<Button onClick={onClose}>{translate('common:CANCEL')}</Button>}
        >
            <List>
                {options.map((option) => (
                    <ListItemButton
                        key={option._id}
                        selected={option._id === selectedId}
                        onClick={() => onSelect(option._id)}
                    >
                        <ListItemText
                            primary={
                                option.isStandardPriceList
                                    ? `${option.name} (${translate('common:DEFAULT').toLowerCase()})`
                                    : option.name
                            }
                            secondary={option.currency}
                        />
                    </ListItemButton>
                ))}
            </List>
        </DHDialog>
    );
};

export default PriceListSelectorDialog;
